<template>
  <div v-if="init" class="amap-text-layer-tool">
    <Teleport to="#amap-control">
      <div :class="{ 'text-control': true, 'text-active': showText }">
        <el-tooltip content="文字图层" effect="dark" placement="left">
          <img src="@p-v/packages/Map/AMapChart/assets/tag.png" alt="文字图层" class="text-icon" @click="toggleText" />
        </el-tooltip>
      </div>
    </Teleport>
  </div>
</template>

<script lang="ts" setup>
import { ref, inject, watch, computed, onMounted } from "vue"
import { ElTooltip } from "element-plus"

defineOptions({
  name: "AMapTextLayer",
})

const props = defineProps({
  // 是否初始化完成
  show: {
    type: Boolean,
    default: false,
  },
})
const init = ref<boolean>(false)

const emit = defineEmits(["text-toggle"])

// 从父组件注入地图实例
const amap = inject<any>("amap")
const mapFeatures = inject<any>("mapFeatures")

// 文字图层状态
const showText = computed(() => {
  // 如果地图特性中包含"point"，则表示文字图层已显示
  return mapFeatures.value.includes("point")
})

// 监听地图实例变化
watch(
  () => amap.value,
  map => {
    if (map) {
      // 初始化文字图层工具
      console.log("初始化文字图层工具", map)
      init.value = true
    }
  },
  { immediate: true },
)

// 切换文字图层显示/隐藏
const toggleText = () => {
  if (!amap.value) return

  if (!showText.value) {
    // 显示文字
    showTextLayer()
  } else {
    // 隐藏文字
    hideTextLayer()
  }

  // 发送状态变更事件
  emit("text-toggle", showText.value)
}

// 显示文字图层
const showTextLayer = () => {
  if (!amap.value) return
  if (mapFeatures.value.includes("point")) {
    // 如果地图已经包含文字特性，则不需要重复设置
    return
  }
  mapFeatures.value.push("point")
  // 设置地图显示所有特性（包括POI文字）
  amap.value.setFeatures(mapFeatures.value)
}

// 隐藏文字图层
const hideTextLayer = () => {
  if (!amap.value) return

  if (!mapFeatures.value.includes("point")) {
    // 如果地图已经包含文字特性，则不需要重复设置
    return
  }
  mapFeatures.value = mapFeatures.value.filter((feature: string) => feature !== "point")
  // 设置地图显示所有特性（包括POI文字）
  amap.value.setFeatures(mapFeatures.value)
}
onMounted(() => {
  if (props.show) {
    showTextLayer()
  } else {
    hideTextLayer()
  }
})
// 暴露方法
defineExpose({
  toggleText,
  showTextLayer,
  hideTextLayer,
})
</script>

<style scoped>
.amap-text-layer-tool {
  /* 不需要定位，因为使用了 Teleport */
}

.text-control {
  background-color: white;
  padding: 5px;
  filter: grayscale(1); /* 默认显示文字，所以默认不灰度 */
  img {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
}

.text-active {
  filter: grayscale(0);
}
</style>
